<template>
  <div>
   <div class="containersvg">
     <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="100%" height="100%" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd; border: 2px solid #f3f3f3; border-radius:10px; position: relative;"
     viewBox="0 0 200 200"
     xmlns:xlink="http://www.w3.org/1999/xlink">

     <defs>  
       <mask id="colar">
        <!-- <rect x="0" y="0" width="200" height="100" /> -->
        <path :d="pontos.molde" fill="white"  />
        <ellipse :cx="pontos.colar.cx" :cy="pontos.colar.cy" :rx="pontos.colar.rx" :ry="pontos.colar.ry" fill="black" />
      </mask >
    </defs>

    <path :d="pontos.molde" :style="estilo" mask="url(#colar)" />
  </svg>

</div>
</div>
</template>


<script>
//70 altura do colar

export default {
  name: 'SVGMolde',
  data () {
    return {
      // pontos:""
      showgrid:true
    }
  },
  props:["modelo","estilo"],
  computed:{
   torax: function(){
    return this.$store.state.torax
  },
  cintura: function(){
    return this.$store.state.cintura
  },
  quadril: function(){
    return this.$store.state.quadril
  },
  gancho: function(){
    return this.$store.state.gancho
  },
  pontos(){
    let fator = 300/200
    let dsvg = 300;
    let csvg = dsvg/2;
    let t = parseInt(this.modelo.torax)
    let c = parseInt(this.modelo.cintura)
    let q = parseInt(this.modelo.quadril)
    let g = parseInt(this.modelo.gancho)
    let margem = 10
    // let t = 75
    // let c = 66
    // let q = 87
    // let g = 120
    // let entreAlca = 80
    let entreAlca = t-(t*0.2)
    let at = (g*0.3) // altura torax 30% do gancho
    let ac = (g*0.4) // altura cintura 40% do gancho
    let aq = (g*0.3) // altura quadril 30% do gancho

    let py = ((g-100/fator)/2) // posição y
    let px = 100/fator // posição x
    this.showgrid = false

    var path = "M "+(px+(px-entreAlca)/2)+", "+py // posicionamento inicial
    path += "l "+entreAlca+" 0"
    path += "q -10,"+(at/2)+" "+((t - entreAlca)/2 )+","+at
    path += "l -"+(t)+" 0"
    path += "q 20,-"+(at/2)+" "+((t - entreAlca)/2 )+",-"+(at)
    path += "z"
    path +="M "+((px+(px-entreAlca)/2) - (t - entreAlca)/2)+" "+(py+at)
    // path +="M "+((px+(px-entreAlca)/2)+(entreAlca/2)-t/2)+" "+(py+at)
    path += "l "+(t)+" 0"
    path += "q "+((c-t)/2)+","+(ac/2)+" "+((q-t)/2)+","+ac
    path += "l -"+(q)+" 0"
    path += "q "+(((t-c)/2)-(t-q)/2)+",-"+(ac/2)+" "+((q-t)/2)+",-"+(ac)
    path += "z"
    path +="M "+((px+(px-t)/2) - ((q - t))/2)+" "+(py+at+ac)
    path += "l "+(q)+" 0"
    path += "q -"+((q-aq)/2)+","+(aq/2)+" "+(-q/2+10)+","+aq
    path += "l -20 0"
    path += "q -"+((q/aq)*2)+", -"+(aq/2)+" "+(-q/2+10)+",-"+aq
    path += "z"
    
    // cx="150" cy="40" rx="15" ry="30"
    let colar={
      cx:(px+(px-entreAlca)/2)+(entreAlca/2),
      cy:py-(at*0.2),
      rx:(entreAlca/2)*0.5,
      ry:at*0.9
    }

    return {molde:path,colar}
  }

},
created: function () {

},
methods:{
  MostrarInfo:function(){

  },
}
}
</script>


<style >

</style>



// WEBPACK FOOTER //
// src/components/partes/SVG.vue